import { Column, Editing, Item, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';

export const ParkSoforleri = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const ref = useRef();
    const mountedRef = useRef(true);

    let skipValidationCheck = false;

    useEffect(() => {
        fetchData();
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.post("parkDriver/getAll");
            if (mountedRef.current) {
                setDataSources(response.data.data || []);
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching park drivers:", error);
        }
    };

    const addModel = async (data, e) => {
        data.create_user_id = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));

        try {
            const response = await api.post("parkDriver/create", data);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Ekleme başarılı"));
                fetchData();
            }
        } catch (error) {
            console.error("Error adding park driver:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const updateModel = async (e, data) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...data.oldData, ...data.newData, update_user_id: employeeId };
        try {
            const response = await api.post("parkDriver/update", body);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Güncelleme başarılı"));
                fetchData();
            }
        } catch (error) {
            console.error("Error updating park driver:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addModel(e.newData, e);
            } else {
                updateModel(e, e);
            }
        }
    };

    return (
        <Card className="p-4">
            <DatagridCustom
                dataSource={dataSources}
                reff={ref}
                onRowValidating={onRowValidating}
                onInitNewRow={(e) => {
                    e.data.is_active = true;
                    e.component.__addingStart = true;
                }}
            >
                <Editing
                    mode="row"
                    popup={{
                        title: t("Yeni Park Şoförü"),
                        showTitle: true,
                        width: 700,
                        height: "auto",
                    }}
                    allowUpdating
                    allowAdding
                    useIcons
                />
                <Column dataField="driver_code" caption={t("Şoför Kodu")} selectedFilterOperation='contains' alignment='center'>
                    <RequiredRule />
                </Column>
                <Column dataField="name" caption={t("Adı Soyadı")} selectedFilterOperation='contains' alignment='center'>
                    <RequiredRule />
                </Column>
                <Column
                    dataField="registration_number"
                    caption={t("Sicil Numarası")}
                    selectedFilterOperation='contains'
                    alignment='center'
                >
                    <RequiredRule />
                </Column>
                <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" selectedFilterOperation='contains' alignment='center'>

                </Column>

                <Toolbar>
                    <Item name="addRowButton" />
                    <Item location="after">
                        <RxButton
                            color="light"
                            outline
                            onClick={fetchData}
                            style={{
                                paddingInline: "10px",
                                border: "1px solid #ddd"
                            }}
                        >
                            <i className="fa fa-refresh"></i>
                        </RxButton>
                        &nbsp;
                        <RxButton
                            className='btn btn-success'
                            style={{
                                color: "white",
                                paddingInline: "10px",
                            }}
                            onClick={(e) => ButtonOnExporting(e, ref, "Park Şoförleri")}>
                            <i className="fa fa-file-excel-o"></i>
                        </RxButton>
                    </Item>
                </Toolbar>
            </DatagridCustom>
        </Card>
    );
};